import {
    useMemo,
} from 'react'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import useOrderManagementRoutes from 'app/SkyNetRoutes/hooks/useOrderManagementRoutes'
import SkyNetObjectProfile from 'app/shared-components/SkyNetObjectProfile'
import domainConfig from './LongTermInvoices.config'

export default function LongTermInvoices() {
    const {
        LongTermLease: LongTermLeaseRoutes,
    } = useOrderManagementRoutes() as Record<string, any>

    const params = useMemo(() => {
        return {
            getLongTermLeaseLink: (id: number) => {
                return id
                    ? generateSkyNetLink({
                        domainPath: LongTermLeaseRoutes.Invoices.path,
                        params: {
                            key: id,
                        },
                    })
                    : null
            },
        }
    }, [LongTermLeaseRoutes.Invoices.path])

    return (
        <SkyNetObjectProfile
            config={domainConfig}
            params={params}
        />
    )
}
